import { ImagenOptimizada } from "shared-components/Components/Image/_new_web";
import "./styles.less";
import { EmblaGalleryCarousel } from "src/Components/EmblaCarousel";
import { useSerpSignalsV2 } from "shared-components/GlobalHooks/useSerpSignalsV2";

export interface DataImages {
	id: number;
	image: string;
	tag: any;
}
interface CardGallery {
	id: string;
	width: number;
	height: number;
	link: string;
	title: string;
	rel: string;
	showPagination?: boolean;
	target: string;
	images: DataImages[];
	shortCard?: boolean;
	hasflag?: boolean;
}

export const CardImageGallery = ({
	id,
	link = "#",
	target = "_self",
	rel = null,
	images = [],
	showPagination = true,
	width,
	height,
	hasflag = false,
}: CardGallery) => {
	// INF-140 — contador de fotos en modo puntitos (flag SERP_SIGNALS_V2, solo fincaraiz).
	// Con el flag apagado, dotsPagination es false → sigue el contador de texto 1/N.
	const dotsPagination = useSerpSignalsV2();
	return (
		<div className="cardImageGallery">
			{images && images.length > 0 ? (
				<EmblaGalleryCarousel
					title={`gallery-slide${id}`}
					totalSlides={images.length}
					link={link}
					hasflag={hasflag}
					dotsPagination={dotsPagination}
					target={target}
					rel={rel}
					options={{
						navigation: true,
						pagination: showPagination,
						loop: true
					}}
				>
					{images.map((g: DataImages, i: number) => {
						const keyValue = `gallery-${g.id ?? id}-listing-item-${i}`;

						return (
							<div className={"gallery-image embla__slide__number"} key={keyValue}>
								<ImagenOptimizada
									src={g.image ?? ""}
									alt="Image"
									width={width}
									height={height}
									propertyId={id}
								/>
							</div>
						);
					})}
				</EmblaGalleryCarousel>
			) : (
				<></>
			)}
		</div>
	);
};

